import React from 'react';
import PackCard from '../PackCard';
import { LangContext } from '../../contexts/LangContext';
import './EventItems.css';

export default function EventItems({ items = [], server, onAddToCart, cart = {}, onQtyChange, onRemove, isEligibleForGift = false, purchasedSkus = [], promotionLink = null, giftLink = null, variant = 'default' }) {
  const { t } = React.useContext(LangContext);
  const ei = t.component.eventItems;

  return (
    <div className="event-items-wrapper">
      {isEligibleForGift && (
        <div className="event-banner">
          <span className="banner-title">{ei.bannerTitle}</span>
          <span className="banner-text">{ei.bannerText}</span>
          <div className="banner-bubble-wrapper">
            <span className="banner-bubble">?</span>
            <div className="banner-tooltip">{ei.bannerTooltip}</div>
          </div>
        </div>
      )}
      <div className={`packs-grid${variant === 'loki' ? ' packs-grid--loki' : ''}`}>
        {items.map((item, index) => (
          <PackCard
            key={item.sku}
            item={item}
            server={server}
            onAddToCart={onAddToCart}
            cartQty={cart[item.sku]?.qty || 0}
            onQtyChange={onQtyChange}
            onRemove={onRemove}
            isElegibleForGift={!purchasedSkus.includes(item.sku)}
            promotionLink={promotionLink}
            giftLink={giftLink}
            packIndex={index}
            variant={variant}
          />
        ))}
      </div>
    </div>
  );
}
